import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

// Note: We're assuming these images are available from the same location
// If they need to be hosted elsewhere, the paths would need to be updated

const AboutUsSection = () => {
  const navigate = useNavigate();

  const handleAboutUsClick = () => {
    navigate("/about-us"); // Replace with your actual route
  };
  return (
    <Box
      component="section"
      sx={{
        bgcolor: "white",
        px: { xs: 2, md: 12.5 },
        py: { xs: 6, md: 8 },
      }}
    >
      <Grid
        container
        columnSpacing={{ xs: 0, md: 6 }}
        rowSpacing={{ xs: 4, md: 0 }}
        alignItems="center"
        sx={{
          flexDirection: { xs: "column-reverse", md: "row" },
        }}
      >
        <Grid item xs={12} md={6}>
          <Stack
            spacing={{ xs: 2.5, md: 3.5 }}
            sx={{
              maxWidth: { xs: "600px", md: "100%" },
              mx: "auto",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontFamily: "'Jost-Bold', Montserrat",
                color: "#1f164f",
                fontSize: { xs: 36, sm: 42, md: 64 },
                fontWeight: 700,
                letterSpacing: { xs: "-2px", sm: "-3px", md: "-3.84px" },
                lineHeight: { xs: 1.2, md: 1.1 },
              }}
            >
              WHO WE ARE
            </Typography>

            <Stack spacing={2}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "'Poppins-Regular', Montserrat",
                  color: "black",
                  fontSize: { xs: 14, sm: 15, md: 16 },
                  lineHeight: 1.6,
                }}
              >
                Apna Card is a seamless digital solution for instant
                connections. Share your contact details with a tap using NFC or
                let others scan your QR code—no more paper exchanges.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontFamily: "'Poppins-Regular', Montserrat",
                  color: "black",
                  fontSize: { xs: 14, sm: 15, md: 16 },
                  lineHeight: 1.6,
                }}
              >
                Apna Card goes beyond contact sharing. Capture leads, track
                interactions, and integrate with your CRM to nurture your
                network and grow your business. Export data to Excel or CSV,
                identify potential clients, and make smarter marketing
                decisions.
              </Typography>
            </Stack>

            <Button
              onClick={handleAboutUsClick}
              variant="contained"
              endIcon={<ArrowOutwardIcon />}
              sx={{
                bgcolor: "#1f164f",
                borderRadius: "10px",
                width: { xs: "100%", sm: "fit-content" },
                alignSelf: { xs: "center", md: "flex-start" },
                minWidth: { xs: "100%", sm: 220 },
                height: { xs: 48, md: 55 },
                fontFamily: "'Istok_Web-Bold', Montserrat",
                fontWeight: 700,
                fontSize: { xs: 14, sm: 15, md: 16 },
                letterSpacing: "-0.64px",
                "&:hover": {
                  bgcolor: "#2a1c6a",
                },
              }}
            >
              ABOUT US
            </Button>
          </Stack>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          sx={{
            textAlign: { xs: "center", md: "right" },
            display: "flex",
            justifyContent: { xs: "center", md: "flex-end" },
          }}
        >
          <Box
            component="img"
            src={"/websiteAssets/AboutUsWhoWeAre.png"} // Replace with the actual image path
            alt="Team members"
            sx={{
              width: { xs: "100%", sm: "85%", md: "100%" },
              maxWidth: { xs: 480, md: 615 },
              height: "auto",
              maxHeight: { xs: 320, md: 420 },
              objectFit: "cover",
              borderRadius: { xs: "18px", md: "24px" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutUsSection;
